export default __webpack_public_path__ + "static/media/img_option_b.18595b04.svg";